export default "__VITE_ASSET__H19VRt$z__"